/** Allowed symbols for consumer/provider signup (historical /sign-up rule). */
export const PASSWORD_SYMBOL_RE =
  /[!@#$%^&*()_\-+=[\]{}|;:,.<>/?]/;

/** Shown when the password does not satisfy {@link isPasswordValid}. */
export const PASSWORD_REQUIREMENTS_HELPER_TEXT =
  '8+ characters with uppercase, lowercase, number & symbol';

export function getPasswordRuleStatus(password) {
  const p = password ?? '';
  return {
    minLength: p.length >= 8,
    longLength: p.length >= 12,
    lowercase: /[a-z]/.test(p),
    uppercase: /[A-Z]/.test(p),
    digit: /\d/.test(p),
    symbol: PASSWORD_SYMBOL_RE.test(p),
  };
}

export function isPasswordValid(password) {
  const r = getPasswordRuleStatus(password);
  return (
    r.minLength &&
    r.lowercase &&
    r.uppercase &&
    r.digit &&
    r.symbol
  );
}

/**
 * @returns {string|null} Error message for API/step validation, or null if OK.
 */
export function getPasswordValidationError(password) {
  if (!password || !String(password).length) return 'Password is required';
  if (!isPasswordValid(password)) return PASSWORD_REQUIREMENTS_HELPER_TEXT;
  return null;
}

const STRENGTH_MAX = 6;

/**
 * Strength bar fills by one segment per: 8+ chars, 12+ chars, lowercase, uppercase, digit, symbol.
 */
export function getPasswordStrength(password) {
  if (!password) {
    return {
      score: 0,
      maxScore: STRENGTH_MAX,
      label: '',
      color: '',
    };
  }

  const r = getPasswordRuleStatus(password);
  let score = 0;
  if (r.minLength) score++;
  if (r.longLength) score++;
  if (r.lowercase) score++;
  if (r.uppercase) score++;
  if (r.digit) score++;
  if (r.symbol) score++;

  let label = 'Weak';
  let color = '#e74c3c';
  if (score <= 2) {
    label = 'Weak';
    color = '#e74c3c';
  } else if (score === 3) {
    label = 'Fair';
    color = '#f39c12';
  } else if (score === 4) {
    label = 'Good';
    color = '#3498db';
  } else if (score === 5) {
    label = 'Strong';
    color = '#01ebb2';
  } else {
    label = 'Very Strong';
    color = '#01ebb2';
  }

  return { score, maxScore: STRENGTH_MAX, label, color };
}
